import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '', redirectTo: 'home', pathMatch: 'full'
  },
  {
    path: 'home',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
      },
      {
        path: 'app/:title',
        loadChildren: () => import('./pages/app/app.module').then(m => m.AppPageModule),
      },
      {
        path: 'videochat',
        loadChildren: () => import('./pages/videochat/videochat.module').then(m => m.VideochatModule),
      },
      {
        outlet: 'overlay',
        path: 'screensaver',
        loadChildren: () => import('./pages/screensaver/screensaver.module').then(m => m.ScreensaverPageModule)
      },
      {
        outlet: 'overlay',
        path: 'menu',
        loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuModule)
      },
      {
        outlet: 'overlay',
        path: 'recommendation',
        loadChildren: () => import('./pages/recommendation/recommendation.module').then(m => m.RecommendationModule)
      },
      {
        outlet: 'overlay',
        path: 'share',
        loadChildren: () => import('./pages/share/share.module').then(m => m.ShareModule)
      },
      {
        outlet: 'overlay',
        path: 'videochat',
        loadChildren: () => import('./pages/videochat/videochat.module').then(m => m.VideochatModule)
      },
      {
        outlet: 'overlay',
        path: 'legal',
        loadChildren: () => import('./pages/legal/legal.module').then(m => m.LegalModule)
      },
      {
        outlet: 'overlay',
        path: 'search',
        loadChildren: () => import('./pages/search/search.module').then(m => m.SearchModule)
      }
    ]
  },
  {
    outlet: 'overlay',
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuModule)
  },
  {
    outlet: 'overlay',
    path: 'recommendation',
    loadChildren: () => import('./pages/recommendation/recommendation.module').then(m => m.RecommendationModule)
  },
  {
    outlet: 'overlay',
    path: 'share',
    loadChildren: () => import('./pages/share/share.module').then(m => m.ShareModule)
  },
  {
    outlet: 'overlay',
    path: 'videochat',
    loadChildren: () => import('./pages/videochat/videochat.module').then(m => m.VideochatModule)
  },
  {
    outlet: 'overlay',
    path: 'legal',
    loadChildren: () => import('./pages/legal/legal.module').then(m => m.LegalModule)
  },
  {
    outlet: 'overlay',
    path: 'search',
    loadChildren: () => import('./pages/search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'gallery',
    outlet: 'overlay',
    loadChildren: () => import('./pages/gallery/gallery.module').then(m => m.GalleryPageModule)
  },
  {
    path: 'webcam',
    outlet: 'overlay',
    loadChildren: () => import('./pages/webcam/webcam.module').then(m => m.WebcamPageModule)
  },
  {
    path: 'document',
    outlet: 'overlay',
    loadChildren: () => import('./pages/document/document.module').then(m => m.DocumentPageModule)
  },
  {
    path: 'person',
    outlet: 'overlay',
    loadChildren: () => import('./pages/person/person.module').then(m => m.PersonPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
